import React, { Component } from 'react';

class Activity extends Component
{
    render()
    {
        return (
            <div>
                Activity
            </div>
        )
    }
}

export default Activity;


// WEBPACK FOOTER //
// ./src/components/Activity/Activity.js